<template>
  <div class="list-root">
    <query-condition-box>
      <el-form
        :inline="true"
        size="small"
        :model="searchParams"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="24">
            <datePicker
              :setDate="setDate"
              @changeDate="changeDate"
            ></datePicker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态：">
              <el-radio-group v-model="searchParams.status" size="small">
                <el-radio-button
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="学段学科：" v-if="searchParams.status === 2">
              <el-select
                style="width: 200px"
                v-model="courseVal"
                clearable
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="searchParams.status === 2">
              <el-input
                v-model.trim="searchParams.title"
                style="width: 200px"
                placeholder="请输入资料名称"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="searchParams.status === 2">
              <el-input
                v-model.trim="searchParams.uploader"
                style="width: 200px"
                placeholder="请输入上传人用户名"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchClick"
                >查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportExcel"
                >导出
              </el-button>
            </el-form-item>
            <el-form-item
              style="float: right !important; margin-right: 0 !important"
            >
              <el-button
                type="primary"
                icon="el-icon-upload2"
                @click="goUploadRes"
                size="small"
                >上传资料
              </el-button>
            </el-form-item>
            <auth-dialog
              :dialog-visible.sync="auth.flag"
              :tip-type="auth.tipType"
            ></auth-dialog>
          </el-col>
          <resource-re-audit
            :dialog-visible.sync="documentReAudit.flag"
            :resource-id="documentReAudit.resourceId"
            :resource-title="documentReAudit.resourceTitle"
            :resource-course-id="documentReAudit.courseId"
          ></resource-re-audit>
        </el-row>
      </el-form>
    </query-condition-box>

    <div class="result-container">
      <xkw-table
        :header-cell-style="{ background: '#f8f8f9', 'text-align': 'center' }"
        v-loading="loading"
        :data="tableList"
        v-model="tableName"
      >
        <el-table-column label="资料名称" width="350">
          <template v-slot="scope">
            <el-link
              style="color: #606266"
              v-if="scope.row.status === '已通过'"
              type="primary"
              :underline="false"
              @click="openUrl(scope.row)"
              >{{ scope.row.title }}
            </el-link>
            <span v-if="scope.row.status !== '已通过'">{{
              scope.row.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="course"
          width="100"
          label="学段学科"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          width="70"
          label="等级"
        >
          <template v-slot="scope">
            <span v-if="scope.row.status !== '待审核'">
              <span v-if="scope.row.commercialLevel === '1202'">普通</span>
              <span v-if="scope.row.commercialLevel === '1203'">精品</span>
              <span v-if="scope.row.commercialLevel === '1204'">特供</span>
              <span v-if="scope.row.commercialLevel === '1205'">教辅</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="价格"
          width="100"
        >
          <template slot-scope="scope">
            <span
              v-if="
                (scope.row.status === '已通过' ||
                  scope.row.status === '退稿') &&
                scope.row.price === '0.0元'
              "
              >免费</span
            >
            <span v-else-if="scope.row.price === '0.0元'"></span>
            <span v-else>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="viewNum"
          width="100"
          label="浏览量"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="frontDownloadNum"
          width="115"
          label="支付订单数"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="feeBackMoney"
          label="分成收入"
          width="130"
        >
          <template v-slot="{ row }">
            {{
              row.feeBackMoney === 0
                ? row.feeBackMoney + ".0元"
                : row.feeBackMoney + "元"
            }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          width="200"
          label="上传时间"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="uploader"
          label="上传人"
          width="150"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          width="100"
          label="状态"
        >
          <template v-slot="{ row }">
            <span>{{ row.status }}</span>
            <i
              v-if="row.status === '退稿' && row.rejectReason !== null"
              class="question-icon"
              @click="getDetail(row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.status === '待审核'"
              @click="editResource(scope.row)"
              :underline="false"
              type="primary"
              >编辑
            </el-link>
            <el-link
              v-if="scope.row.status === '已通过'"
              @click="showEditPrice(scope.row)"
              type="primary"
              :underline="false"
              >定价
            </el-link>
            <span v-if="scope.row.status === '退稿'"
              ><el-link
                :underline="false"
                type="primary"
                @click="updateResource(scope.row)"
                >修改 </el-link
              >&nbsp;
              <el-link
                type="primary"
                :underline="false"
                @click="resourceReAuditClick(scope.row)"
                >申诉
              </el-link></span
            >
          </template>
        </el-table-column>
      </xkw-table>
      <el-pagination
        v-show="total !== null && total !== 0"
        background
        style="text-align: right; padding: 10px"
        :current-page.sync="searchParams.pageIndex"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>

      <el-dialog
        title="资料定价"
        :visible.sync="dialogVisible"
        width="30%"
        @close="tipFlag = false"
      >
        <div class="one-line">
          <span style="color: red; margin-left: 60px">*</span>
          <span>价格</span>
          <span style="margin-left: 5px">
            <el-tooltip
              effect="dark"
              content="超出限制范围请联系运营处理"
              placement="top-start"
            >
              <el-button
                class="el-icon-question"
                style="padding: 0; border: 0; height: auto; position: relative"
              />
            </el-tooltip>
          </span>
          <span
            style="display: inline-block; margin-left: 50px"
            class="price-input"
          >
            <el-input size="small" v-model="newPrice"
          /></span>
        </div>
        <div class="one-line" style="margin-top: 10px">
          <span style="color: red; margin-left: 165px">
            <span v-if="tipFlag && editRowCommercialLevel == '1203'">
              请输入0-10内的整数
            </span>
            <span v-if="tipFlag && editRowCommercialLevel == '1202'">
              请输入0-5内的整数
            </span>
            <span v-if="tipFlag && editRowCommercialLevel == '1205'">
              请输入0-50内的整数
            </span>
          </span>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <span style="text-align: center">
            <el-button
              type="primary"
              @click="updateDocumentPrice()"
              size="small"
              >确 定</el-button
            >
          </span>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 30px">
          <span
            style="color: red; text-align: center"
            v-if="editRowCommercialLevel == '1202'"
            >当前资料等级为普通，定价范围是0-5元<br />每月可修改价格2次，为促进用户下载，请合理定价</span
          >
          <span
            style="color: red; text-align: center"
            v-if="editRowCommercialLevel == '1203'"
            >当前资料等级为精品，定价范围是0-10元<br />每月可修改价格2次，为促进用户下载，请合理定价</span
          >
          <span
            style="color: red; text-align: center"
            v-if="editRowCommercialLevel == '1205'"
            >当前资料等级为教辅，定价范围是0-50元<br />每月可修改价格2次，为促进用户下载，请合理定价</span
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import api from "../../../assets/js/api";
import AuthDialog from "@/components/auth-dialog.vue";
import { isOpenPermissionDialog, objectToQueryString } from "@/assets/js/utils";
import shopCenterConst from "@/assets/js/shopCenterConst";
import datePicker from "@/components/common/date-picker.vue";
import ResourceReAudit from "@/components/resource-reAudit.vue";

export default {
  computed: {},
  components: { ResourceReAudit, datePicker, AuthDialog },
  data() {
    return {
      documentReAudit: {
        flag: false,
        resourceId: null,
        resourceTitle: null,
        courseId: null,
      },
      auth: {
        flag: false,
        tipType: null,
      },
      courseList: [
        {
          value: null,
          label: "全部",
        },
      ],
      page: 1,
      tableList: [],
      created: "",
      dialogVisible: false,
      loading: false,
      tableName: "合同列表",
      total: 0,
      timeRadio: "近7天",
      courseVal: null,
      searchParams: {
        courseIds: null,
        time: "month",
        from: "",
        to: "",
        status: 0,
        shopId: this.$store.state.user.userInfo.shopId,
        title: "",
        pageSize: 10,
        pageIndex: 1,
        documentType: 1,
        uploader: null,
      },
      editRowCommercialLevel: null,
      statusList: [
        { id: 0, name: "不限" },
        { id: 1, name: "待审核" },
        { id: 2, name: "已通过" },
        { id: 3, name: "退稿" },
      ],
      tipFlag: false,
      newPrice: "",
      editPriceRow: {},
      //弹窗埋点
      pay_window_view: {
        $event_name: "shopcenter_res_price_change", //埋点名称
      },
      setDate: {}, // 时间控件的时间段 默认传空对象即可
    };
  },
  created() {
    if (this.$route.params.pageIndex) {
      this.searchParams.pageIndex = this.$route.params.pageIndex;
    }
    this.getCourseList();
  },
  mounted() {
    // this.setTime();
    if (this.$route.params.pageIndex) {
      this.searchParams.from = this.$route.params.from;
      this.searchParams.to = this.$route.params.to;
      this.searchParams.time = this.$route.params.time;
      this.searchParams.status = this.$route.params.status;
      this.searchParams.title = this.$route.params.title;
      this.searchParams.pageIndex = this.$route.params.pageIndex;
      // 设置时间控件的时间段
      this.setDate = {
        startTime: this.$route.params.from,
        endTime: this.$route.params.to,
        timeAlias: this.$route.params.time,
      };
    }
    this.getTableList();
  },
  methods: {
    async resourceReAuditClick(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;

      const checkResult = await this.$axios.post(
        api.shopResource.hadPostResourceRejectReAudit +
          "?resourceId=" +
          row.resourceId
      );
      if (checkResult.result) {
        this.$message.error("您已提交过申诉，请关注站内信的处理结果");
        return;
      }
      this.documentReAudit.flag = true;
      this.documentReAudit.resourceId = row.resourceId;
      this.documentReAudit.resourceTitle = row.title;
      this.documentReAudit.courseId = row.courseId;
    },
    async updateResource(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      // await this.$router.push({
      //   path: "/resource/means",
      //   query: {
      //     resourceId: row.resourceId,
      //     operationType: 1,
      //   },
      // });
      if (row.rbmStatus === "废除") {
        this.$message.error("资料被永久退稿，无法修改，如有异议可点击申诉");
        return;
      }
      const checkRejectRes = await this.$axios.get(
        api.shopResource.checkResourceRejectDate,
        { id: row.resourceId }
      );
      if (checkRejectRes.result) {
        this.$message.error("资料退稿已超过7天，无法修改");
        return;
      }

      const checkResult = await this.$axios.get(
        api.shopResource.checkResourceRukuStatus,
        { id: row.resourceId }
      );
      if (!checkResult.result) {
        this.$message.error("资料入库中，请稍后再试");
        return;
      }
      if ("审核中" === row.rbmStatus) {
        this.$message.error("资料正在审核，请稍后再试");
        return;
      }
      this.$router.push({
        name: "resource-document-upload",
        params: {
          time: this.searchParams.time,
          from: this.searchParams.from,
          to: this.searchParams.to,
          status: this.searchParams.status,
          pageIndex: this.searchParams.pageIndex,
          title: this.searchParams.title,
        },
        query: {
          resourceId: row.resourceId,
          operationType: 1,
        },
      });
    },
    openUrl(row) {
      window.open(`//www.zxxk.com/soft/${row.resourceId}.html`);
    },
    changeDate(e) {
      this.searchParams.from = e.startTime;
      this.searchParams.to = e.endTime;
      this.searchParams.time = e.timeAlias;
    },
    async exportExcel() {
      if (!this.searchParams.from) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.searchParams.to) {
        this.$message.error("请选择结束时间");
        return;
      }
      let _that = this;
      _that.searchParams.pageIndex = 1;
      _that.setFromToTime();
      const tableList = await _that.$axios.post(
        api.shopResource.pageResourceInfoList,
        this.searchParams
      );
      if (tableList.result.list == null || tableList.result.totalCount <= 0) {
        _that.$message.warning("无数据");
        return;
      } else if (tableList.result.totalCount >= shopCenterConst.excel.maxNum) {
        _that.$message.warning(shopCenterConst.excel.tip);
        return;
      }

      window.open(
        api.shopResource.exportDocumentList +
          "?" +
          objectToQueryString(this.searchParams)
      );
    },
    async getCourseList() {
      const resourceResult = await this.$axios.get(
        api.dataShow.getCourseList4Data
      );
      this.courseList.push(
        ...resourceResult.result.map((item) => ({
          value: item.id,
          label: item.name,
          children: item.children,
        }))
      );
    },
    async updateDocumentPrice() {
      if (this.editPriceRow.price == this.newPrice) {
        this.dialogVisible = false;
        this.$message.success("资料价格调整成功");
        return true;
      }

      if (this.editRowCommercialLevel == "1202") {
        //普通
        //0-5范围内的整数
        if (
          !(this.newPrice % 1 === 0 && this.newPrice >= 0 && this.newPrice <= 5)
        ) {
          this.tipFlag = true;
          return false;
        }
      } else if (this.editRowCommercialLevel == "1203") {
        //精品
        //0-10范围内的整数
        if (
          !(
            this.newPrice % 1 === 0 &&
            this.newPrice >= 0 &&
            this.newPrice <= 10
          )
        ) {
          this.tipFlag = true;
          return false;
        }
      } else if (this.editRowCommercialLevel == "1205") {
        //第三方
        //0-50范围内的整数
        if (
          !(
            this.newPrice % 1 === 0 &&
            this.newPrice >= 0 &&
            this.newPrice <= 50
          )
        ) {
          this.tipFlag = true;
          return false;
        }
      }

      var request = {
        documentId: this.editPriceRow.resourceId,
        price: this.newPrice,
      };
      const result = await this.$axios.post(
        api.resource.updateDocumentPrice,
        request
      );
      if (!result.valid && result.error.message) {
        this.$message.error(result.error.message);
        return;
      }
      if (result.valid) {
        if (result.result) {
          //在特定的时机发送数据
          window.easyData.send(this.pay_window_view);
          this.$message.success("资料价格调整成功，信息更新略有延迟");
          this.dialogVisible = false;
          await this.getTableList();
          return true;
        }
      }
      this.$message.error("资料价格调整失败，请联系客服");
    },
    getPrice() {
      this.newPrice = this.editPriceRow.price.replace("元", "");
    },
    async showEditPrice(param) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 2 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      const priceCheckResult = await this.$axios.post(
        api.resource.getUpdatePriceCheck + "?documentId=" + param.resourceId
      );
      if (!priceCheckResult.valid && priceCheckResult.error.message) {
        this.$message.error(priceCheckResult.error.message);
        return;
      }
      const result = await this.$axios.get(
        api.resource.getUpdateDocumentPriceFrequency +
          "?documentId=" +
          param.resourceId
      );
      if (result && result.valid) {
        if (result.result < 2) {
          this.editPriceRow = param;
          this.dialogVisible = true;
          this.editRowCommercialLevel = param.commercialLevel;
          this.getPrice();
          return;
        } else {
          this.$message.error("每月仅可修改价格2次!");
        }
      } else {
        this.$message.error("服务器错误，请联系客服！");
      }
    },

    setTime() {
      let timeType = this.searchParams.time;
      var nowData = new Date();
      var startTime = new Date();
      if (timeType == "yesterday") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 1));
      } else if (timeType == "week") {
        startTime = new Date(new Date().setDate(new Date().getDate() - 7));
      } else if (timeType == "month") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 1));
      } else if (timeType == "threeMonthes") {
        startTime = new Date(new Date().setMonth(new Date().getMonth() - 3));
      } else if (timeType == "year") {
        startTime = new Date(new Date().setYear(new Date().getFullYear() - 1));
      }
      if (this.searchParams.from != null) {
        let month = startTime.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = startTime.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.searchParams.from =
          startTime.getFullYear() + "-" + month + "-" + day;
      }
      if (this.searchParams.to != null) {
        let month = nowData.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = nowData.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.searchParams.to = nowData.getFullYear() + "-" + month + "-" + day;
      }
    },
    setCookie(name, value, daysToLive) {
      let cookie = name + "=" + encodeURIComponent(value);
      // console.log(cookie);
      if (typeof daysToLive == "number") {
        cookie += ";max-age=" + daysToLive * 60 * 60 * 24;
      }
      cookie += ";Path=" + escape("/");
      document.cookie = cookie;
    },
    goUploadRes() {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      // await this.$router.push({
      //   path: "/resource/means",
      // });

      this.$router.push({
        name: "resource-document-upload",
        params: {
          time: this.searchParams.time,
          from: this.searchParams.from,
          to: this.searchParams.to,
          status: this.searchParams.status,
          pageIndex: this.searchParams.pageIndex,
          title: this.searchParams.title,
        },
      });
    },
    // async editPrice(row) {
    //   this.setCookie("resourceId", row.resourceId);
    //   this.setCookie("operationType", "2");
    //   location.replace("/resource/video");
    // },
    // 查看资源
    getDetail(row) {
      this.$confirm(row.rejectReason, "退稿原因", {
        dangerouslyUseHTMLString: true, // 是否将 message 属性作为 HTML 片段处理
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
    },
    // 编辑资源
    async editResource(row) {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      // await this.$router.push({
      //   path: "/resource/means",
      //   query: {
      //     resourceId: row.resourceId,
      //     operationType: 1,
      //   },
      // });
      const checkResult = await this.$axios.get(
        api.shopResource.checkResourceRukuStatus,
        { id: row.resourceId }
      );
      if (!checkResult.result) {
        this.$message.error("资料入库中，请稍后再试");
        return;
      }
      if ("审核中" === row.rbmStatus) {
        this.$message.error("资料正在审核，请稍后再试");
        return;
      }
      this.$router.push({
        name: "resource-document-upload",
        params: {
          time: this.searchParams.time,
          from: this.searchParams.from,
          to: this.searchParams.to,
          status: this.searchParams.status,
          pageIndex: this.searchParams.pageIndex,
          title: this.searchParams.title,
        },
        query: {
          resourceId: row.resourceId,
          operationType: 1,
        },
      });
    },
    //搜索按钮
    searchClick() {
      if (!this.searchParams.from) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.searchParams.to) {
        this.$message.error("请选择结束时间");
        return;
      }
      // 将查询时间段 同步给时间控件（针对时间控件中时间段不完整的情况）
      this.setDate = {
        startTime: this.searchParams.from,
        endTime: this.searchParams.to,
        timeAlias: this.searchParams.time,
      };
      this.searchParams.pageIndex = 1;
      this.searchParams.courseIds = null;
      for (const course of this.courseList) {
        if (
          this.courseVal &&
          course.children &&
          this.courseVal === course.value
        ) {
          // console.log(course);
          this.searchParams.courseIds = course.children
            .map((c) => c.id)
            .join(",");
        }
      }
      if (!this.searchParams.courseIds) {
        this.searchParams.courseIds = this.courseVal;
      }
      this.getTableList();
    },
    //获取列表
    async getTableList() {
      this.loading = true;
      this.setFromToTime();
      const tableList = await this.$axios.post(
        api.shopResource.pageResourceInfoList,
        this.searchParams
      );
      this.tableList = tableList.result.list;
      this.total = tableList.result.totalCount;
      this.loading = false;
    },
    //设置时间控件
    setFromToTime() {
      if (this.searchParams.from == null) {
        return;
      }
      if (this.searchParams.to == null) {
        return;
      }
      if (this.searchParams.from.indexOf("00:00:00") === -1) {
        this.searchParams.from = this.searchParams.from + " 00:00:00";
      }
      if (this.searchParams.to.indexOf("23:59:59") === -1) {
        this.searchParams.to = this.searchParams.to + " 23:59:59";
      }
    },
    // 修改当前页
    handleCurrentChange(pageIndex) {
      this.searchParams.pageIndex = pageIndex;
      //请求
      this.getTableList();
    },
  },
};
</script>
<style lang="scss" scoped>
.question-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url(../../../assets/images/question-circle.png);
  background-size: contain;
  background-repeat: no-repeat;
  vertical-align: middle;
  cursor: pointer;
  margin-bottom: 2px;
  margin-left: 2px;
}

.result-container {
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}

.title {
  margin-bottom: 10px;
}

.property {
  font-size: 14px;
  color: #666;
  margin-right: 20px;
}

.free {
  color: #5a83ff;
}

//::v-deep .has-gutter .el-table__cell {
//  &:first-of-type {
//    text-align: left !important;
//  }
//}

::v-deep .el-table thead {
  color: #333 !important;
}
</style>
<style lang="css">
.price-input .el-input__inner {
  width: 150px;
}

.overflow {
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
}
</style>
